<template>
  <div>
    <header-page :namePage="$t('sidebar.menu.settingTime')" />
    <div class="content">
      <div class="form-container">
        <div class="form">
          <div>
            <div class="form-input">
              <label class="label label_mb5">
                {{ $t("mc.detailsMc.segment") }}
              </label>
              <v-select
                :searchable="false"
                :clearable="false"
                :options="segmentList"
                v-model="selectedSegment"
                label="title"
                @input="changeSegment">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <img src="@/assets/svg/select-chevron.svg" />
                  </span>
                </template>
                <template #option="{ id, title }">
                  <span>({{ id }}) {{ title }}</span>
                </template>
                <template #selected-option="{ id, title, tz_offset }">
                  <span>({{ id }}) {{ title }}, offset: {{ tz_offset }}</span>
                </template>
              </v-select>
            </div>
            <div class="form-input">
              <label class="label label_mb5">
                {{ $t("settingTime.newTz") }}
              </label>
              <input
                type="text"
                class="input-text"
                v-model="newTzOffset"
                @keypress="isNumber($event)" />
            </div>
            <div class="form-input">
              <label class="label label_mb5">
                {{ $t("settingTime.oldTz") }}
              </label>
              <input
                type="text"
                class="input-text"
                v-model="oldTzOffset"
                @keypress="isNumber($event)" />
            </div>
          </div>
          <div>
            <div class="form-input">
              <label class="label label_mb5">
                {{ $t("settingTime.startDate") }}
              </label>
              <datepicker
                class="form-calendar"
                :clearable="false"
                v-model="startCalendar"
                format="DD.MM.YYYY"
                valueType="format"
                :lang="globalSettingCalendar">
                <i slot="icon-calendar">
                  <inline-svg
                    :src="require(`@/assets/svg/picker-calendar.svg`)" />
                </i>
              </datepicker>
            </div>
            <div class="form-input">
              <label class="label label_mb5">
                {{ $t("settingTime.endDate") }}
              </label>
              <datepicker
                class="form-calendar"
                :clearable="false"
                v-model="endCalendar"
                format="DD.MM.YYYY"
                valueType="format"
                :lang="globalSettingCalendar">
                <i slot="icon-calendar">
                  <inline-svg
                    :src="require(`@/assets/svg/picker-calendar.svg`)" />
                </i>
              </datepicker>
            </div>
            <div class="form-input">
              <label class="label label_mb5">&nbsp;</label>
              <button
                class="btn btn_blue btn_h46"
                :disabled="disabledSave"
                @click="saveTz">
                {{ $t("mc.buttons.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalSettingCalendar from "@/helpers/globalSettingCalendar";
import apiBooking from "@/api/master-classes/booking";
export default {
  data() {
    return {
      globalSettingCalendar,
      segmentList: [],
      selectedSegment: "",
      newTzOffset: "",
      oldTzOffset: "",
      startCalendar: "",
      endCalendar: "",
    };
  },
  computed: {
    disabledSave() {
      return (
        !this.selectedSegment ||
        !this.newTzOffset.length ||
        !this.oldTzOffset.length ||
        !this.startCalendar
      );
    },
  },
  methods: {
    changeSegment(segment) {
      this.selectedSegment = segment;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 45 &&
        charCode !== 109 &&
        charCode !== 189
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async saveTz() {
      const object = {
        segment: this.selectedSegment.id,
        old_tz_offset: this.oldTzOffset,
        new_tz_offset: this.newTzOffset,
        start_date: this.$dayjs(this.startCalendar, "DD.MM.YYYY").format(
          "YYYY-MM-DD 00:00:00.000000"
        ),
      };
      if (this.endCalendar) {
        object.end_date = this.$dayjs(this.endCalendar, "DD.MM.YYYY").format(
          "YYYY-MM-DD 00:00:00.000000"
        );
      }
      await apiBooking.migrateSummerTime(object);
    },
  },
  created() {
    this.segmentList = this.$store.state.user.segmentsList;
    this.selectedSegment = this.segmentList[0];
  },
};
</script>

<style lang="scss" scoped>
.form {
  // max-width: 300px;
  display: grid;
  grid-template-columns: 300px 1fr;
  column-gap: 30px;
  &-input {
    margin-bottom: 10px;
  }
  &-container {
    background: #fff;
    padding: 20px;
  }
  &-calendar {
    & .mx-input {
      height: 46px;
    }
  }
}
</style>
